import { TaskLimitDropdownSubstitute } from "@/components/PricingPage/TaskLimitDropdownSubstitute";
import { Currency, Plan } from "@/types";

import { Dropdown } from "./Dropdown";
import { TaskLimitDropdownListItem } from "./TaskLimitDropdownListItem";
import { getKFormat } from "@/utils";

type TaskLimitDropdownProps = {
  /** The type of currency to display. */
  currency: Currency;
  /** For annual, prices are divided by 12 so we display /month price */
  isAnnual: boolean;
  /** The function that runs when the PlanActionButton is clicked. */
  onSelect: (plan: Plan) => void;
  /** The options to choose from in the dropdown */
  options: Plan[];
  /** The currently selected plan */
  selectedPlan: Plan;
};

const getSelectedItem = (plan: Plan): string =>
  `${getKFormat(Number(plan.tasks))} tasks /mo`;

/**
 * A component that renders a dropdown with task limit details.
 */
export const TaskLimitDropdown = ({
  currency,
  isAnnual,
  onSelect,
  options,
  selectedPlan,
}: TaskLimitDropdownProps) => {
  return options.length > 1 ? (
    <Dropdown
      ariaLabel="Task Limit"
      getLabelForListItems={(item: Plan) => (
        <TaskLimitDropdownListItem
          currency={currency}
          isAnnual={isAnnual}
          plan={item}
        />
      )}
      getLabelForSelectedItem={(item: Plan) => getSelectedItem(item)}
      initialSelectedItem={selectedPlan}
      items={options}
      menuAriaLabel="List of available task limits"
      onChange={onSelect}
      placeholder="Choose a task limit..."
      size="small"
    />
  ) : (
    <TaskLimitDropdownSubstitute text={getSelectedItem(selectedPlan)} />
  );
};
